import { createSlice } from "@reduxjs/toolkit";

const initialBenefisCategoryState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  benefisCategoryForEdit: undefined,
  lastError: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const benefisCategorySlice = createSlice({
  name: "benefisCategory",
  initialState: initialBenefisCategoryState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getBenefisCategoryById
    benefisCategoryFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.benefisCategoryForEdit = action.payload.benefisCategoryForEdit;
    },
    // findBenefisCategory
    benefisCategorysFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    // Set to default state actionLoading & error
    benefisCategoryReload: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
    },
  },
});
